// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "af1cc8c27e617ec99bf38545d2fb6c89a9ff8328/static/css/" + chunkId + "." + {"481":"144724f8","729":"40937596","820":"a5137a1f"}[chunkId] + ".chunk.css";
};